import { useEffect } from 'react'

/** O que o `public/index.html` traz, e o que a aba mostrava em **todas** as 108 rotas. */
export const APP_TITLE = 'Painel ABRA'

/**
 * Escreve o título da aba a partir do título da tela, e o devolve ao sair.
 *
 * Nenhuma página do painel escrevia `document.title`: as 108 rotas mostravam `Painel ABRA`, então
 * uma segunda aba do painel era indistinguível da primeira e o histórico do navegador guardava
 * 108 entradas com o mesmo nome. O hook não é chamado pelas páginas — é chamado pelos **três**
 * componentes que emitem o `h1` do painel (`PageTitle`, `DetailHero` e `PublicFormLayout`), que é
 * exatamente a mesma informação num lugar só.
 *
 * `title` vazio (ou `undefined`, enquanto o registro ainda está sendo buscado) deixa o título de
 * fábrica — melhor do que piscar um `undefined` na aba.
 */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    if (!title) return

    document.title = `${title} | ${APP_TITLE}`

    return () => {
      document.title = APP_TITLE
    }
  }, [title])
}
